import { ListIcon } from "../icons";
import List from "./List";

export default {
	options: {
		group: "automation",
		roles: ["admin", "user"],
	},
	icon: ListIcon,
	list: List,
};
